import {BaseFetchModel} from "../../../infrastructure/models/base-fetch-model";
import {FETCH_METHODS} from "../../../core/consts";

export class CommentsFetchModel extends BaseFetchModel {
  selection: Number;
  provider: String;
  token: String;
  key: String;

  constructor(selection: Number, token: String = "", key: String = "", provider: String= "DV_WEB") {
    super(FETCH_METHODS.post);

    this.selection = selection;
    this.key = key;
    this.provider = provider;
    this.token = token;
  }

  get body(): String {
    const requestBody: Object = {
      selection: this.selection,
      slug: this.key,
      user: {
        provider: this.provider,
        token: this.token
      }
    }

    return JSON.stringify(requestBody);
  }

  get headers(): Headers {
    return new Headers({'content-type': 'application/json; charset=utf-8'});
  }

  equals(model: CommentsFetchModel): * {
    return this.body === model.body;
  }
}
